<template>
  <section class="livratos-double-section">
    <div class="container">
      <h3>Plus de détail&nbsp;?</h3>

      <!-- Étape 1 : Inscription -->
      <div class="livratos-row">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/register-livratos.webp"
              alt="Inscription de l’artisan sur la plateforme Livratos"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 1 • Inscription</p>
            <h2>
              Crée ton espace<br />
              entreprise / artisan
            </h2>
            <p>
              L’inscription est simple et rapide : vous ouvrez votre compte en
              quelques secondes, puis vous accédez à votre espace personnel pour
              compléter les informations essentielles de votre entreprise. C’est
              ici que vous indiquez votre structure, votre zone d’activité et
              les éléments nécessaires à l’activation de votre service. Une fois
              votre profil complété, notre équipe vous contacte pour finaliser
              la mise en route, répondre à vos questions, vous présenter la
              plateforme si besoin et vous accompagner jusqu’au lancement
              opérationnel.
            </p>
            <ul class="features-list">
              <li>
                Un espace Artisan facile à prendre en main, pensé pour les pro
                du BTP.
              </li>
              <li>
                Un profil complet : coordonnées professionnelles, documents
                officiels, zone d’activité Livratos.
              </li>
              <li>
                Accompagnement personnalisé avant l’activation (appel, démo,
                aide au paramétrage).
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Étape 2 : Activation du compte -->
      <div class="livratos-row reverse">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/register-livratos-2.webp"
              alt="Activation du compte artisan par l’équipe Livratos"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 2 • Activation</p>
            <h2>
              Validation de ton profil,<br />
              paramétrage de tes chantiers
            </h2>
            <p>
              Une fois votre profil complété, notre équipe vérifie vos
              informations et revient vers vous pour finaliser l’activation de
              votre espace Artisan. Cet échange nous permet de nous assurer que
              tout est en ordre, de répondre à vos questions et, si vous le
              souhaitez, de vous présenter la plateforme ou de vous accompagner
              sur les premiers pas. Dès validation, votre compte est activé et
              vous pouvez commencer à organiser vos livraisons.
            </p>
            <ul class="features-list">
              <li>
                Contrôle des informations de votre activités d'<strong
                  >artisan ou entreprise dans le BTP</strong
                >
                et validation de votre profil.
              </li>
              <li>
                Appel de bienvenue&nbsp;: explications, démo si besoin et aide
                au paramétrage initial.
              </li>
              <li>
                Accompagnement de démarrage (prise en main rapide par vous ou
                vos équipes).
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Étape 3 : Création des livraisons -->
      <div class="livratos-row">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/chargement-item.webp"
              alt="Création d’une livraison pour un chantier artisan"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 3 • Création des livraisons</p>
            <h2>
              Depuis le bureau ou le <strong>chantier</strong>,<br />
              déclenchez la bonne course
            </h2>
            <p>
              Tu crées tes <strong>livraisons express</strong> ou
              programmées&nbsp;: fournisseur, point de retrait, adresse
              <strong>chantier</strong>, créneau d’arrivée et type de véhicule.
              La plateforme affecte un
              <strong>livreur indépendant</strong> adapté et tu suis la course
              jusqu’à la remise du matériel sur site.
            </p>
            <ul class="features-list">
              <li>
                Demande de <strong>livraison</strong> depuis le bureau ou
                directement depuis le chantier.
              </li>
              <li>
                Informations complètes&nbsp;: contact sur place, accès,
                contraintes horaires.
              </li>
              <li>
                Suivi en temps réel des statuts (en attente, en transit,
                <strong>livrée</strong>, interrompue).
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Étape 4 : Facturation -->
      <div class="livratos-row reverse">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/billing-delivery.webp"
              alt="Facturation des livraisons pour les artisans"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 4 • Facturation</p>
            <h2>
              Courses regroupées,<br />
              vision claire par chantier
            </h2>
            <p>
              Toutes les <strong>livraisons</strong> réalisées sont regroupées
              par période (8&nbsp;jours ou fin de mois). Tu reçois une facture
              unique avec le détail des courses, des
              <strong>chantiers livrés</strong> et des montants associés&nbsp;:
              idéal pour suivre tes coûts logistiques
              <strong>chantier</strong> par <strong>chantier</strong>.
            </p>
            <ul class="features-list">
              <li>
                Facture récapitulative unique, prête à transmettre à la compta
                ou à l’expert-comptable.
              </li>
              <li>
                Détail des courses par <strong>chantier</strong> pour analyser
                la rentabilité.
              </li>
              <li>
                Moins d’administratif&nbsp;: pas de paiement course par course,
                tout est consolidé.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LivratosDoubleSectionArtisans",
};
</script>

<style lang="scss" scoped>
.livratos-double-section {
  background-color: $background;
  padding: 80px 20px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 60px;

    @media (min-width: 992px) {
      gap: 80px;
    }
  }

  h3 {
    font-size: 1.4rem;
    font-weight: 600;
    color: $color-text;
    margin-bottom: 0.5rem;
  }

  .livratos-row {
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (min-width: 992px) {
      flex-direction: row;
      gap: 32px;
      align-items: stretch;
    }

    &.reverse {
      @media (min-width: 992px) {
        flex-direction: row-reverse;
      }
    }

    .livratos-col {
      flex: 1;
      display: flex;
      align-items: stretch;
    }

    .livratos-image-card {
      background-color: $color-primary;
      border-radius: 16px;
      padding: 3px;
      width: 100%;
      box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18),
        0 6px 16px rgba(0, 0, 0, 0.12);

      display: flex;
      align-items: center;
      justify-content: center;

      @media (min-width: 992px) {
        padding: 22px;
      }

      img {
        width: 100%;
        border-radius: 12px;
        object-fit: cover;
        display: block;
      }
    }

    .livratos-text-card {
      background-color: #000;
      border-radius: 16px;
      padding: 22px 22px 24px;
      width: 100%;
      color: #fff;
      box-shadow: 0 20px 45px rgba(0, 0, 0, 0.28), 0 8px 20px rgba(0, 0, 0, 0.2);

      @media (min-width: 768px) {
        padding: 26px 28px 30px;
      }

      .badge {
        display: inline-block;
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        padding: 0.25rem 0.8rem;
        border-radius: 999px;
        background: rgba($color-primary, 0.18);
        color: $color-primary;
        font-weight: 600;
        margin-bottom: 0.85rem;
      }

      h2 {
        font-size: 1.6rem;
        font-weight: 700;
        color: #ffffff;

        @media (min-width: 768px) {
          font-size: 2.1rem;
        }
      }

      p {
        margin-top: 1rem;
        font-size: 0.98rem;
        color: rgba(255, 255, 255, 0.85);

        @media (min-width: 768px) {
          font-size: 1.05rem;
        }
      }

      .features-list {
        margin-top: 1.1rem;
        padding-left: 0;
        list-style: none;

        li {
          position: relative;
          padding-left: 1.2rem;
          margin-bottom: 0.4rem;
          font-size: 0.95rem;
          color: rgba(255, 255, 255, 0.85);

          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0.55em;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background-color: $color-primary;
            transform: translateY(-50%);
            box-shadow: 0 0 0 2px rgba($color-primary, 0.25);
          }
        }
      }
    }
  }
}
</style>
